var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48613 1.79912L11.7168 6.21845L16.0101 6.64378C16.2188 6.66113 16.3984 6.79829 16.47 6.99509C16.5416 7.19188 16.4922 7.41236 16.3435 7.55978L12.8101 11.0618L14.1201 15.8204C14.1749 16.0266 14.1036 16.2457 13.938 16.3802C13.7724 16.5147 13.5434 16.5396 13.3528 16.4438L9.00013 14.2884L4.65346 16.4411C4.46288 16.5369 4.23381 16.5121 4.06823 16.3776C3.90266 16.2431 3.83138 16.024 3.88613 15.8178L5.19613 11.0591L1.66013 7.55712C1.51138 7.4097 1.46198 7.18922 1.53359 6.99242C1.60521 6.79562 1.78476 6.65846 1.99346 6.64112L6.28679 6.21578L8.51413 1.79912C8.60752 1.61671 8.7952 1.50195 9.00013 1.50195C9.20506 1.50195 9.39273 1.61671 9.48613 1.79912Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/rating-star.442333cfb835e9e8f117bc9a921145ef.svg";
export { ForwardRef as ReactComponent };